import { connect } from 'react-redux';
import { selectPythonVersion } from 'src/ReduxStorage/Application/selectors';
import { ReduxState } from 'src/ReduxStorage/state';
import { Footer } from './component';

export const ConnectedFooter = connect((state: ReduxState) => ({
  pythonVersion: selectPythonVersion(state),
}))(Footer);
